import styles from "../aic.module.css";
import { AibLineDisplay } from "./AibLineDisplay";
import { useBlockContext } from "./BlockContentProvider";

/**
 * Container element for the block
 */
export const AibBlock = () => {
  const { state } = useBlockContext();
  return (
    <div
      id={state.id}
      className={styles.aibBlock}
    >
      {state.lines.map((l, li) => (
        <AibLineDisplay
          key={`${li}-${l.aifid}`}
          aifid={l.aifid}
        />
      ))}
    </div>
  );
};

AibBlock.displayName = "AibBlock";
